import React from 'react';
// import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import NavigationItem from './NavigationItem';

const DesktopMenu = (props) => {

	const {
		locationId,
		pages,
		onClose
	} = props;

	// eslint-disable-next-line
	const locationPages = pages.filter(x => x.locationId == locationId && x.showInMenu);

	if(!locationPages || locationPages.length === 0 || locationId == null) {
		return null;
	} else {
		return (
			<div className='desktopMenu'>
				<ul className='navigationItems'>
					{locationPages.map(locationPage => {
						const className = locationPage.component.toLowerCase();
						let menuItem = <NavigationItem itemClass={className} key={locationPage.id} link={locationPage.url} alt={locationPage.pageDescription} linkText={locationPage.menuText} />;

						if(locationPage.subMenuItems && locationPage.subMenuItems.length > 0) {
							const sortedItems = locationPage.subMenuItems.sort((a, b) => (a.Order > b.Order) ? 1 : -1);
							const subMenu = sortedItems.map((sortedItem) => {
								// eslint-disable-next-line
								const subMenuItem = pages.filter(x => x.id == sortedItem.LocationPageId);
								if(subMenuItem && subMenuItem.length === 1) {
									return <NavigationItem key={sortedItem.LocationPageId} listKey={sortedItem.LocationPageId} link={subMenuItem[0].url} alt={subMenuItem[0].pageDescription} onClick={onClose} linkText={subMenuItem[0].menuText} />
								} else {
									return null;
								}
							});

							menuItem = (
								<NavigationItem key={locationPage.id} listKey={locationPage.id} link={locationPage.url} alt={locationPage.pageDescription} onClick={onClose} linkText={locationPage.menuText}>
									<div className='subMenuContainer'>
										<ul className='subMenu'>
											{subMenu}
										</ul>
									</div>
								</NavigationItem>
							);
						}

						return menuItem;

						// return <NavigationItem itemClass={className} key={locationPage.id} link={locationPage.url} alt={locationPage.pageDescription} linkText={locationPage.name} style={{ width: menuItemWidth + '%'}} />;
					})}
				</ul>
			</div>
		);
	}
};

const mapStateToProps = state => {
	return {
		pages: state.application.pages
	};
};

export default withRouter(connect(mapStateToProps, null)(DesktopMenu));
